/*
*  Main component for the Mobile View of the dashboard
*
* Copyright (C) 2018, 2019 Sterilis Solutions LLC all rights reserved.
*/
import React from 'react';
import { withTranslation as translate} from "react-i18next";
import PressureTemperatureGraph from "./PressureTemperatureGraph";
import CycleSummary from "./CycleSummary";
import UserPieChart from "./UserPieChart";
import DashboardNav from "./DashboardNav";
import BiochallengeChart from "./BiochallengeChart";
import get from 'lodash/get';
import DashboardCycleTable from "./DashboardCycleTable";
import WasteProcessedSummary from "./WasteProcessedSummary";

const DashboardMobile = props => (
  props.isLoading === false ?
    <div className='customer-container-mobile'>
      <DashboardNav
        toDateClick={props.toDateClick}
        fromDateClick={props.fromDateClick}
        fromDate={props.fromDate}
        toDate={props.toDate}
        prepareDashboard={props.prepareDashboard}
        customerMachines={props.customerMachines}
        selectDevice={props.selectDevice}
        deviceConfigID={props.deviceConfigID}
        selectedCycle={props.selectedCycle}
        pageInactive={props.pageInactive}
        refreshData={props.refreshData}
        filterCustomerDevices={props.filterCustomerDevices}
      />
      {get(props.biochallengeInfo, 'is_airport', false) ?
        null :
        <BiochallengeChart
          graphContainerClass='graph-container--mobile dashboard-container'
          className='flex-item'
          dashboardResized={true}
          biochallengeInfo={props.biochallengeInfo}
          userTimezone={props.userTimezone}
          deviceTimezone={props.deviceTimezone}

        />
      }
      <CycleSummary
        graphContainerClass='graph-container--mobile'
        dashboardResized={true}
        userTimezone={props.userTimezone}
        deviceCycles={props.deviceCycles}
        deviceFacility={props.deviceFacility}
      />
      <UserPieChart
        graphContainerClass='graph-container--mobile'
        dashboardResized={true}
        deviceCycles={props.deviceCycles}
      />
      <WasteProcessedSummary
        graphContainerClass='graph-container--mobile'
        className='flex-item'
        dashboardResized={true}
        deviceCycles={props.deviceCycles}
        userTimezone={props.userTimezone}
        deviceFacility={props.deviceFacility}
        weight_unit={props.weight_unit}
      />
      <PressureTemperatureGraph
        graphContainerClass='graph-container--mobile'
        dashboardResized={true}
        cycleEvents={props.cycleEvents}
        cycleMetadata={props.cycleMetadata}
        userTimezone={props.userTimezone}
        deviceTimezone={props.deviceTimezone}
        setCurrentPressureUnit={props.setCurrentPressureUnit}
        currentPressureUnit={props.currentPressureUnit}
        deviceSerial={props.deviceSerial}
      />
      <DashboardCycleTable
        dashboardSize='mobile'
        deviceConfigID={props.deviceConfigID}
        deviceCycles={props.deviceCycles}
        userTimezone={props.userTimezone}
        deviceTimezone={props.deviceTimezone}
        className='flex-item'
        fetchCycleEvents={props.fetchCycleEvents}
        complianceReport={props.complianceReport}
        comprehensiveReport={props.comprehensiveReport}
        setComprehensiveReport={props.setComprehensiveReport}
        setComplianceReport={props.setComplianceReport}
        expandCycleTable={props.expandCycleTable}
        fromDate={props.fromDate}
        toDate={props.toDate}
        deviceFacilityFullAddress={props.deviceFacilityFullAddress}
        isAirport={get(props.biochallengeInfo, 'is_airport', false)}
        deviceSerial={props.deviceSerial}
        currentPressureUnit={props.currentPressureUnit}
      />
    </div>
  : null
);

export default translate('translations')(DashboardMobile);
